// Copyright (c) 2020-2022 Visual Intelligence LP. All rights reserved.
//
import Axios from 'axios';
import { injectable } from 'inversify';

import StaffUser, { StaffUserDTO } from '@shared/models/staff-user';

@injectable()
export default class ProfileService {
  protected urlPrefix = 'profile';
  static diToken = Symbol('profile-service');

  async get(): Promise<StaffUser> {
    try {
      const { data } = await Axios.get<Partial<StaffUserDTO>>(this.urlPrefix);
      return new StaffUser(data);
    } 
    catch (err) {
      throw err;
    }
  }
// Update profile or alarms
  edit(data: Partial<StaffUserDTO>): Promise<void> {
    if (data.taskAlarms === undefined)
    {
      return Axios.put(this.urlPrefix, data);
    }
    return Axios.put(this.urlPrefix + '/alarms', data.taskAlarms);
  }
}
